/* istanbul ignore file */
// Ignoring coverage for since it is just a wrapper of qs
import qs from 'qs';

/** Wrapper around the `qs.parse`. */
export const paramsParser = (parameters: string, options?: qs.IParseOptions) => {
    return qs.parse(parameters, options);
};
